<template>
  <vue-custom-scrollbar class="scroll_wrap">
    <v-row
      class="ma-0 px-6 px-md-15 py-5 bg-gray"
      align="center"
      justify="space-between"
    >
      <v-col cols="auto" class="pa-0">
        <v-row class="ma-0" align="center">
          <v-col cols="auto" class="pa-0 mr-5">
            <v-img src="~@/img/main_img_assignment.png"></v-img>
          </v-col>
          <v-col cols="auto" class="pa-0">
            <span class="tab-title mr-4">{{ $t('전형안내 및 결과') }} </span>
            <span class="count">{{ resultList.length }}</span>
            <span class="unit">&nbsp;{{ $t('건') }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mx-0 mx-md-15 mt-4 mt-md-8 mb-0">
      <v-col class="pa-0">
        <template
          v-for="(noticeGroup, type) in groupBy(resultList, 'notiType')"
        >
          <v-row
            :key="type"
            class="ma-0 px-6 py-4 bg-gray bd-B-2px"
            align="center"
            justify="space-between"
          >
            <v-col cols="auto" class="pa-0 head-title">{{
              type == 'INTERVIEW' ? $t('전형안내') : $t('결과안내')
            }}</v-col>
            <v-col cols="auto" class="pa-0">
              <a class="submit-count">{{ noticeGroup.length }}</a
              >{{ $t('건') }}
            </v-col>
          </v-row>
          <!-- only PC -->
          <v-row
            v-for="(notice, idx) in noticeGroup"
            class="ma-0 py-5 px-6 bd-B-1px d-none d-md-flex"
            align="center"
            justify="space-between"
            :key="'notice-pc' + idx + notice.id.addStepId + notice.notiType"
          >
            <v-col cols="" class="pa-0 list-title">{{ notice.title }}</v-col>
            <v-col cols="auto" class="pa-0 ml-10 date-created"
              >{{ $t('조회기간')
              }}<span class="ml-3"
                >{{ notice.startDate | momentDate('YYYY-MM-DD') }}~{{
                  notice.endDate | momentDate('YYYY-MM-DD')
                }}</span
              ><span
                class="ml-8"
                :class="{ complete: notice.complete }"
                v-if="type == 'INTERVIEW' && notice.absenceBtnYn == 'Y'"
                >{{
                  !['ATTEND', 'ABSENCE'].includes(notice.status)
                    ? $t('참석대기')
                    : notice.status == 'ATTEND'
                    ? $t('참석')
                    : $t('불참석')
                }}</span
              ></v-col
            >
            <v-col cols="auto" class="pa-0">
              <i-btn class="ml-6 btn-type-06" @click="openPopup(notice)">
                {{
                  $t(
                    type == 'RESULT'
                      ? '결과확인'
                      : notice.absenceBtnYn == 'Y'
                      ? '참석여부'
                      : '내용확인',
                  )
                }}
              </i-btn>
            </v-col>
          </v-row>
          <!-- only mobile & tablet -->
          <v-row
            v-for="(notice, idx) in noticeGroup"
            class="ma-0 px-6 py-5 bd-B-1px d-sm-block d-md-none"
            align="center"
            justify="space-between"
            :key="'notice-mobile' + idx + notice.id.addStepId + notice.notiType"
          >
            <v-row class="px-3 px-md-0 py-3 py-md-0">
              <v-col>
                <v-row cols="" class="pa-0 list-title">{{
                  notice.title
                }}</v-row>
                <v-row cols="auto" class="pa-0 date-created"
                  >{{ $t('조회기간') }}
                  {{ notice.startDate | momentDate('YYYY-MM-DD') }}~{{
                    notice.endDate | momentDate('YYYY-MM-DD')
                  }}</v-row
                >
                <v-row cols="auto" class="pa-0 pt-3">
                  <i-btn class="ml-6 btn-type-03" @click="openPopup(notice)">
                    {{
                      type == 'RESULT'
                        ? $t('결과확인')
                        : notice.absenceBtnYn == 'Y'
                        ? $t('참석여부')
                        : $t('내용확인')
                    }}
                  </i-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-row>
        </template>
      </v-col>
    </v-row>
    <BasePopup
      v-if="todoNotice"
      v-model="templatePopup"
      :title="todoNotice.title"
      width="600"
    >
      <CommonCkEditor v-model="todoNotice.notiDesc" isReadOnly />

      <template #actions="{close}">
        <v-card-actions
          v-if="todoNotice.absenceBtnYn == 'Y'"
          class="base-popup-content-actions d-flex justify-space-between"
        >
          <v-col cols="6" class="py-0 pl-0" style="padding-right:5px;">
            <i-btn
              block
              outlined
              color="#d5d8dc"
              @click="onAbsenceBtnClick(true, close)"
              elevation="0"
            >
              <span class="black--text">{{ $t('불참석') }}</span>
            </i-btn>
          </v-col>
          <v-col cols="6" class="py-0 pr-0" style="padding-left:5px;">
            <i-btn
              block
              color="#087ef7"
              @click="onAbsenceBtnClick(false, close)"
              elevation="0"
            >
              <span class="white--text">{{ $t('참석') }}</span>
            </i-btn>
          </v-col>
        </v-card-actions>
        <div v-else></div>
      </template>
    </BasePopup>
  </vue-custom-scrollbar>
</template>

<script>
import { API } from '@/api/network';
import { groupBy } from '@/utils/util';
import CommonCkEditor from '@/components/common/CommonCkEditor.vue';
import { surffyProxy } from '@/utils/surffy';

export default {
  components: { CommonCkEditor },
  props: {
    isCurrentTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      templatePopup: false,
      resultList: [],
      noticeAddStepList: [],
      todoNotice: null,
    };
  },
  methods: {
    groupBy,
    async openPopup(notice) {
      await API.getAuthJson('/todoNotice', {
        ...notice.id,
      }); //조회 등록 용
      this.todoNotice = notice;
      if (!this.todoNotice.title) this.todoNotice.title = this.$t('안내');
      this.templatePopup = true;
    },
    async fetchResult() {
      surffyProxy(async clear => {
        this.resultList = [];
        const close = this.$showLoading();
        const { data } = await API.getAuthJson('/todoList/noticeStep').finally(
          close,
        );
        this.resultList = data;
        clear();
      });
    },
    async onAbsenceBtnClick(absenceYn, popupClose) {
      // absenceYn 불참석 === true
      const close = this.$showLoading();
      try {
        await API.postAuthJson('/todo/interview/status', {
          noticeId: this.todoNotice.id,
          absenceYn,
        });
        this.todoNotice.status = absenceYn ? 'ABSENCE' : 'ATTEND';
      } catch (error) {
        console.error(error);
      } finally {
        popupClose();
        close();
      }
    },
  },
  watch: {
    isCurrentTab(v) {
      v && this.fetchResult();
    },
  },
  created() {
    this.fetchResult();
  },
};
</script>

<style></style>
